import { getEnvironment } from '../config/envConfig';

type PathFragment = number | string;
export enum PlanInsightType {
  DELAY = 'delay',
  TIME = 'time',
  SPEED = 'speed',
  IMPACT = 'impact',
  COUNT = 'count',
}
export function isPlanInsightType(value: any): value is PlanInsightType {
  return Object.values(PlanInsightType).some(
    (typeValue) => value === typeValue
  );
}

export enum TeamSectionFragment {
  MEMBERS = 'members',
  GUESTS = 'guests',
}

export function pathLogin() {
  return '/login';
}
export function pathForgotPassword() {
  return '/forgotPassword';
}
export function pathResetPassword() {
  return '/resetPassword';
}
export function pathMfaLogin() {
  return '/mfa';
}
export function pathDashboard() {
  return '/dashboard';
}
export function pathRouteStatus(routeId: PathFragment = ':routeId') {
  return `/route-status/${routeId}`;
}
export function pathRoutePollStatus(routeId: PathFragment = ':routeId') {
  return `/route-poll-status/${routeId}`;
}

export function pathLogout() {
  return '/logout';
}

export function pathImpactAssessmentRequest(
  insightId: PathFragment = ':insightId',
  siteId: PathFragment = ':siteId'
) {
  return `/impact-assessment/${insightId}/${siteId}/request`;
}

export function pathCookies() {
  return '/cookies';
}
export function pathForbidden() {
  return '/forbidden';
}
export function pathOnboarding(onboardingStep: PathFragment = '*') {
  return `/onboarding/${onboardingStep}`;
}

export function pathContractorOnboarding() {
  return '/onboard-contractor';
}

export function pathContractorOnboardingExistingUser() {
  return '/onboard-contractor-existing';
}

export function pathContractorOnboardingExistingUserCreateOrg() {
  return '/onboard-contractor-existing/create-org';
}

export function pathUnsubscribe() {
  return '/unsubscribe';
}
export function pathScorecard(scorecardId: string) {
  return getEnvironment() === 'production'
    ? `https://scorecard.mooven.com?id=${scorecardId}`
    : `https://scorecard.dev.mooven.com?id=${scorecardId}`;
}
